/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { analytics } from 'services/Analytics'
import { comparePlansScroller, selectPlanScroller, benefitsScroller } from 'services/PageScroller'
import { setScrollElementId } from 'redux-app/modules/pageScroller'
import { withLocalization } from 'hocs/localization'
import { withScrollToElements } from 'hocs/withScrollToElements'
import { MENU_ITEM_NAMES } from './constants'
import Main from './Main'

export default compose(
  connect(
    null,
    {
      setScrollElementId,
    },
  ),
  withLocalization('home.main'),
  withRouter,
  withHandlers({
    trackVideoPlay: ({ }) => formValues => {
      analytics.viewVideoOnHomePage()
    },
  }),
  withScrollToElements([comparePlansScroller, selectPlanScroller, benefitsScroller]),
  lifecycle({
    componentDidMount () {
      const { match: { params: { menu } } } = this.props
      if (menu === MENU_ITEM_NAMES.plans) {
        this.props.setScrollElementId(selectPlanScroller.getElementId())
        return
      }
      if (menu === MENU_ITEM_NAMES.benefits) {
        this.props.setScrollElementId(benefitsScroller.getElementId())
        return
      }
      analytics.openHomePage()
    },
  }),
)(Main)
